<template>
  <el-dialog
    ref="dialog"
    :title="title"
    :width="dialogWidth"
    :append-to-body='true'
    :visible="formVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close='closeDialog'
    :style="{'--inputWidth': inputWidth}"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :label-position="labelPosition"
      :inline="formInline"
      :label-width="labelWidth"
      :model="formData"
      :rules="rules"
      :size="formSize"
      :class="formClass"
    >

      <slot/>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading='loading' @click="submitForm('form')">确 定</el-button>
    </div>

  </el-dialog>
</template>

<script>
  export default {
    name: "EditFormDialog",
    props: {
      formType: {
        type: String,
        required: true,
        /*validator: function (value) {
          return [
            'update',
            'add'
          ].indexOf(value) !== -1
        }*/
      },
      formData: {
        type: Object,
        required: true
      },
      formVisible: {
        type: Boolean,
        required: false,
        default: false
      },
      formInline: {
        type: Boolean,
        required: false,
        default: false
      },
      formSize: {
        type: String,
        required: false,
        default: 'medium',
        validator: function (value) {
          return [
            'medium',
            'small',
            'mini'
          ].indexOf(value) !== -1
        }
      },
      formClass: {
        type: String,
        required: false,
        default: 'demo-form-inline dialog_scroll'
      },
      dialogWidth: {
        type: String,
        required: false,
        default: '60%'
      },
      dialogTitle: {
        type: String,
        required: false
      },
      labelWidth: {
        type: String,
        required: false,
        default: '200px'
      },
      rules: {
        type: Object,
        required: false
      },
      labelPosition: {
        type: String,
        required: false,
        default: 'right',
        validator: function (value) {
          return [
            'left',
            'right',
            'top'
          ].indexOf(value) !== -1
        }
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      },
      inputWidth: {
        type: String,
        required: false,
        default: '200px'
      }
    },
    computed: {
      title: {
        get() {
          if(this.dialogTitle) {
            return this.dialogTitle
          } else if (this.formType === 'update') {
            return '编辑'
          } else if(this.formType === 'add') {
            return '添加'
          }
          return ''
        }
      }
    },
    methods: {
      // 关闭弹框
      closeDialog() {
        if (this.formType == 'add') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            this.$emit('closeDialog', this.formType)
            this.$refs.form.clearValidate()
          }).catch(_ => {})
        } else {
          this.$emit('closeDialog', this.formType)
          this.$refs.form.clearValidate()
        }
      },
      // 编辑、添加提交方法
      submitForm(form) {
        this.$refs[form].validate(valid => {
          if (!valid) {
            return false
          }
          this.$confirm('确认提交操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$emit('submitForm')
          }).catch(() => {})
        })
      }
    }
  }
</script>

<style scoped type="less">
  /deep/ .el-dialog .el-dialog__body .el-form-item__content .el-input {
    width: var(--inputWidth);
  }

  /deep/ label {
    font-weight: 700;
  }

  /deep/ .el-textarea {
    width: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/components/EditFormDialog.vue